import {getCookie} from "./CookieUtil"
import {createInputClassName, renderControl, renderInput, renderSelect, simpleRenderInput, renderCheckbox} from "./InputRenderer"
import {getSecurityHeaders} from "./Security"
import {getContentType, isResponseJson, throwIfError, fetchResponseHandler, getXsrfHeader, getXsrfToken, fetchGet, fetchPost, extractMessage, ERROR_CODE_BAD_INPUT} from "./FetchUtil"
import {isAllBlank, isAllNotBlank, isBlank, isNotBlank, trimToEmpty} from "./StringUtil"
import {isFormSubmittable, hasMessage, setFormState, getInputErrorClass, getFormInputCssClass, setupOnExtractData} from "./FormUtil"

import EaseContactInfo from "./EaseContactInfo"
import MessageComponent from "./MessageComponent"
import renderDotComNav from "./DotComNav";
import Drawer from "./Drawer";

const UnoUtil = {
    cookie: {
        getCookie
    },
    inputRenderer: {
        createInputClassName,
        renderControl,
        renderInput,
        renderSelect,
        simpleRenderInput,
        renderCheckbox
    },
    security: {
        getSecurityHeaders
    },
    fetch: {
        getContentType,
        isResponseJson,
        throwIfError,
        fetchResponseHandler,
        getXsrfHeader,
        getXsrfToken,
        fetchGet,
        fetchPost,
        extractMessage,
        ERROR_CODE_BAD_INPUT

    },
    string: {
        isBlank,
        isNotBlank,
        isAllBlank,
        isAllNotBlank,
        trimToEmpty
    },
    form: {
        isFormSubmittable,
        hasMessage,
        setFormState,
        getInputErrorClass,
        getFormInputCssClass,
        setupOnExtractData
    },
    renderDotComNav: renderDotComNav,

    EaseContactInfo,
    MessageComponent,
    Drawer
};

export default UnoUtil;